<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="2">
              <b-form-group id="input-group-29" :label="$t('edu_programs.code')" label-for="input-29">
                <b-form-input id="input-29" v-model="newItem.code" type="text" :placeholder="$t('edu_programs.code')" />
              </b-form-group>
            </b-col>
            <!-- .program_list -->
            <b-col lg="5">
              <b-form-group id="input-group-29" :label="$t('edu_programs.name')" label-for="input-29">
                <b-form-input id="input-29" v-model="newItem.name" type="text" :placeholder="$t('edu_programs.name')" />
              </b-form-group>
            </b-col>
            <b-col lg="5">
              <b-form-group id="input-group-29" :label="$t('edu_programs.name_en')" label-for="input-29">
                <b-form-input id="input-29" v-model="newItem.name_en" type="text"
                  :placeholder="$t('edu_programs.name_en')" />
              </b-form-group>
            </b-col>
            <!-- .explanation -->
            <b-col lg="6">
              <b-form-group id="input-group-30" :label="$t('edu_programs.explanation')" label-for="input-30">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }" v-model="newItem.explanation"
                  :placeholder="$t('edu_programs.explanation')" />
              </b-form-group>
            </b-col>
            <!-- .explanation_en -->
            <b-col lg="6">
              <b-form-group id="input-group-30" :label="$t('edu_programs.explanation_en')" label-for="input-30">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.explanation_en" :placeholder="$t('edu_programs.explanation_en')" />
              </b-form-group>
            </b-col>
            <!-- goals -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.goals')" label-for="input-goals">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }" v-model="newItem.goals"
                  :placeholder="$t('edu_programs.goals')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.goals_en')" label-for="input-goals_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }" v-model="newItem.goals_en"
                  :placeholder="$t('edu_programs.goals_en')" />
              </b-form-group>
            </b-col>

            <!-- study_language -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.study_language')" label-for="input-study_language">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }"
                  v-model="newItem.study_language" :placeholder="$t('edu_programs.study_language')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.study_language_en')" label-for="input-study_language_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.study_language_en" :placeholder="$t('edu_programs.study_language_en')" />
              </b-form-group>
            </b-col>

            <!-- career_horizons -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.career_horizons')" label-for="input-career_horizons">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }"
                  v-model="newItem.career_horizons" :placeholder="$t('edu_programs.career_horizons')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.career_horizons_en')" label-for="input-career_horizons_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.career_horizons_en" :placeholder="$t('edu_programs.career_horizons_en')" />
              </b-form-group>
            </b-col>

            <!-- prerequisites -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.prerequisites')" label-for="input-prerequisites">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }"
                  v-model="newItem.prerequisites" :placeholder="$t('edu_programs.prerequisites')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.prerequisites_en')" label-for="input-prerequisites_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.prerequisites_en" :placeholder="$t('edu_programs.prerequisites_en')" />
              </b-form-group>
            </b-col>

            <!-- study_results -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.study_results')" label-for="input-study_results">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }"
                  v-model="newItem.study_results" :placeholder="$t('edu_programs.study_results')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.study_results_en')" label-for="input-study_results_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.study_results_en" :placeholder="$t('edu_programs.study_results_en')" />
              </b-form-group>
            </b-col>


            <!-- vision -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.vision')" label-for="input-vision">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }" v-model="newItem.vision"
                  :placeholder="$t('edu_programs.vision')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.vision_en')" label-for="input-vision_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }" v-model="newItem.vision_en"
                  :placeholder="$t('edu_programs.vision_en')" />
              </b-form-group>
            </b-col>

            <!-- message -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.message')" label-for="input-message">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }" v-model="newItem.message"
                  :placeholder="$t('edu_programs.message')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.message_en')" label-for="input-message_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }" v-model="newItem.message_en"
                  :placeholder="$t('edu_programs.message_en')" />
              </b-form-group>
            </b-col>

            <!-- research_fields -->
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.research_fields')" label-for="input-research_fields">
                <ckeditor :config="{ contentsLangDirection: 'rtl', versionCheck: false }"
                  v-model="newItem.research_fields" :placeholder="$t('edu_programs.research_fields')" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group :label="$t('edu_programs.research_fields_en')" label-for="input-research_fields_en">
                <ckeditor :config="{ contentsLangDirection: 'ltr', versionCheck: false }"
                  v-model="newItem.research_fields_en" :placeholder="$t('edu_programs.research_fields_en')" />
              </b-form-group>
            </b-col>

            
            <b-col lg="12">
              <b-form-group id="input-group-31" :label="$t('edu_programs.icon')" label-for="input-31">
                <b-form-file id="wildcard" v-model="newItem.profile_image" accept="image/*"
                  :placeholder="$t('edu_programs.icon')" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6" v-if="!wizard">
              <b-form-group id="input-group-1" :label="$t('program_lists.program_list')" label-for="input-1">
                <b-form-select id="input-1" v-model="newItem.program_list_id" :options="program_listOptions"
                  text-field="name" value-field="id" :placeholder="$t('program_lists.program_list')"></b-form-select>
              </b-form-group>
              <!-- .edu_season -->
            </b-col>
            <b-col lg="6" v-if="!wizard">
              <b-form-group id="input-group-2" :label="$t('edu_seasons.edu_season')" label-for="input-2">
                <b-form-select id="input-2" v-model="newItem.edu_season_id" :options="edu_seasonOptions"
                  text-field="name" value-field="id" :placeholder="$t('edu_seasons.edu_season')"
                  @change="changeEduSeason"></b-form-select>
              </b-form-group>
              <!-- .program_type -->
            </b-col>

            <b-col lg="6">
              <b-form-group id="input-group-5" :label="$t('edu_programs.h_study_start_date')" label-for="input-5">
                <date-picker :placeholder="$t('edu_programs.h_study_start_date')" v-model="newItem.h_study_start_date"
                  :locale="'ar-eg'" calendar="hijri" @change="toDateG($event, 'g_study_start_date')" />
              </b-form-group>
              <!-- .g_study_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-6" :label="$t('edu_programs.g_study_start_date')" label-for="input-6">
                <b-form-input id="input-6" v-model="newItem.g_study_start_date" type="text" readonly
                  :placeholder="$t('edu_programs.g_study_start_date')" />
              </b-form-group>
              <!-- .h_study_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-7" :label="$t('edu_programs.h_study_end_date')" label-for="input-7">
                <date-picker :placeholder="$t('edu_programs.h_study_end_date')" v-model="newItem.h_study_end_date"
                  :locale="'ar-eg'" calendar="hijri" @change="toDateG($event, 'g_study_end_date')" />
              </b-form-group>
              <!-- .g_study_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-8" :label="$t('edu_programs.g_study_end_date')" label-for="input-8">
                <b-form-input id="input-8" v-model="newItem.g_study_end_date" type="text" readonly
                  :placeholder="$t('edu_programs.g_study_end_date')" />
              </b-form-group>
              <!-- .h_register_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-9" :label="$t('edu_programs.h_register_start_date')" label-for="input-9">
                <date-picker :placeholder="$t('edu_programs.h_register_start_date')"
                  v-model="newItem.h_register_start_date" :locale="'ar-eg'" calendar="hijri"
                  @change="toDateG($event, 'g_register_start_date')" />
              </b-form-group>
              <!-- .g_register_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-10" :label="$t('edu_programs.g_register_start_date')" label-for="input-10">
                <b-form-input id="input-10" v-model="newItem.g_register_start_date" type="text" readonly
                  :placeholder="$t('edu_programs.g_register_start_date')" />
              </b-form-group>
              <!-- .h_register_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-11" :label="$t('edu_programs.h_register_end_date')" label-for="input-11">
                <date-picker :placeholder="$t('edu_programs.h_register_end_date')" v-model="newItem.h_register_end_date"
                  :locale="'ar-ar'" calendar="hijri" ref="h_register_end_date" :min="newItem.g_register_start_date"
                  @change="toDateG($event, 'g_register_end_date')" />
              </b-form-group>
              <!-- .g_register_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group id="input-group-12" :label="$t('edu_programs.g_register_end_date')" label-for="input-12">
                <b-form-input id="input-12" v-model="newItem.g_register_end_date" type="text" readonly
                  :placeholder="$t('edu_programs.g_register_end_date')" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col md="3">
              <!-- .graduation_year -->
              <b-form-group id="input-group-1" :label="$t('edu_programs.master_program')" label-for="input-1">
                <b-form-checkbox v-model="newItem.is_master" class="custom-control-info" name="check-button" value="1"
                  switch />
              </b-form-group>
            </b-col>
            <b-col md="9" v-if="newItem.is_master == 1">
              <div class="demo-inline-spacing">
                <b-form-radio v-model="newItem.master_type" name="some-radio9" value="1" class="custom-control-primary">
                  ماجستير هيكل أ A
                </b-form-radio>

                <b-form-radio v-model="newItem.master_type" name="some-radio9" value="2" class="custom-control-success">
                  ماجستير هيكل ب B
                </b-form-radio>
                <b-form-radio v-model="newItem.master_type" name="some-radio9" value="3" class="custom-control-danger">
                  ماجستير هيكل ج C
                </b-form-radio>

                <b-form-radio v-model="newItem.master_type" name="some-radio9" value="4" class="custom-control-info">
                  دكتوراه هيكل أ A
                </b-form-radio>
              </div>
            </b-col>
          </b-row>

          <hr />
          <b-row>
            <b-col lg="6">
              <b-button block :disabled="invalid" variant="primary" @click="submit()">
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button>
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/EduProgramsController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
import Program_listsController from "@/Controllers/Program_listsController";
import Edu_seasonsController from "@/Controllers/Edu_seasonsController";
import VueDatetimeJs from "vue-datetime-js";
let controller = new Controller();
export default {
  name: "EduProgramsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    "date-picker": VueDatetimeJs,
  },
  props: ["newItem", "wizard"],
  data() {
    return {
      file: {},

      program_list: [],
      edu_season: [],
      program_listOptions: [],
      edu_seasonOptions: [],
      programType: [],
      program: {},
    };
  },
  async created() {
    this.programType = controller.programType();
    this.program_listOptions = await new Program_listsController().GetAll();
    this.edu_seasonOptions = await new Edu_seasonsController().GetAll();
  },
  methods: {
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await controller.From(this.newItem, "FormData", true);
      if (ret.status) {
        if (this.wizard) {
          this.program = ret[1][0];
        } else {
          this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
          this.$parent.$parent.firstTab();
        }
      }
    },
    getProgram() {
      return this.program;
    },
    toDateG(evt, gdDate) {
      this.newItem[gdDate] = evt.toISOString().split("T")[0];
      // this.$refs.h_register_end_date.min=evt.toISOString().split("T")[0];
    },
    changeEduSeason(value) {
      let eduSeason = this.edu_seasonOptions.find((a) => a.id == value);
      this.$set(this.newItem, "h_study_start_date", eduSeason.h_start_date);
      this.$set(this.newItem, "g_study_start_date", eduSeason.g_start_date);

      this.$set(this.newItem, "h_study_end_date", eduSeason.h_end_date);
      this.$set(this.newItem, "g_study_end_date", eduSeason.g_end_date);
    },
  },
  watch: {
    newItem(value, r) {
      if (value.edu_season_id) {
        this.changeEduSeason(value.edu_season_id);
      }
    },
  },
};
</script>
